import React from "react";

export default function SocialLinks({ mini = false }) {
  return (
    <ul className={mini ? 'social-mini list-inline' : 'social list-inline'}>
      <li className="list-inline-item">
        <a
          href="https://twitter.com/ed_talavera"
          rel="noreferrer"
          target="blank"
          data-toggle="tooltip"
          data-placement="bottom"
          title="mi twitter"
        >
          <i className="fab fa-twitter"></i>
        </a>
      </li>
      <li className="list-inline-item">
        <a
          href="https://www.facebook.com/eduardo.dev.90/"
          rel="noreferrer"
          target="blank"
          data-toggle="tooltip"
          data-placement="bottom"
          title="mi facebook"
        >
          <i className="fab fa-facebook"></i>
        </a>
      </li>
      <li className="list-inline-item">
        <a
          href="https://www.linkedin.com/in/devtaed/"
          rel="noreferrer"
          target="_blank"
          data-toggle="tooltip"
          data-placement="bottom"
          title="mi linkedin"
        >
          <i className="fab fa-linkedin-in"></i>
        </a>
      </li>
      <li className="list-inline-item">
        <a
          href="https://github.com/eduardo-talavera"
          data-toggle="tooltip"
          data-placement="bottom"
          title="mi github"
          rel="noreferrer"
          target="_blank"
        >
          <i className="fab fa-github-alt"></i>
        </a>
      </li>
      {/* <li className="list-inline-item">
        <a
          href="mailto:edtavera3@gmail.com"
          data-toggle="tooltip"
          data-placement="bottom"
          title="mi correo"
          rel="noreferrer"
          target="_blank"
        >
          <i className="fas fa-paper-plane"></i>
        </a>
      </li> */}
      {/* <li className="list-inline-item">
        <a
          href="https://es.stackoverflow.com/users/91298/eduardo-talavera"
          rel="noreferrer"
          target="_blank"
          data-toggle="tooltip"
          data-placement="bottom"
          title="stackoverflow"
        >
          <i className="fab fa-stack-overflow"></i>
        </a>
      </li> */}
      {/* <li className="list-inline-item last-item">
        <a
          href="https://codesandbox.io/u/eduardo-talavera-dev/sandboxes"
          rel="noreferrer"
          target="_blank"
          data-toggle="tooltip"
          data-placement="bottom"
          title="mi codesadbox"
        >
          <i className="fab fa-codepen"></i>
        </a>
      </li> */}
    </ul>
  );
}

